import { exportFromApi, type FileDef } from '@/lib/excel/export';
import type { KhachHangFilterRow } from '@/types/schemas';
import { QUERY_KEYS } from '@/constants';

export type NhaCungCapExportRow = KhachHangFilterRow & {
  status?: string | null;
};

export const NHA_CUNG_CAP_EXPORT_FILE: FileDef<NhaCungCapExportRow> = {
  title: 'DANH MỤC NHÀ CUNG CẤP',
  name: 'Danh mục nhà cung cấp',
  sheet: 'Main',
  cols: [
    { header: 'Mã nhà cung cấp', width: 18, get: row => row.ma_kh || '' },
    { header: 'Tên nhà cung cấp', width: 40, get: row => row.ten_kh || '' },
    { header: 'Mã số thuế', width: 18, get: row => row.ma_so_thue || '' },
    { header: 'Địa chỉ', width: 48, get: row => row.dia_chi || '' },
    { header: 'Mã nhân viên', width: 18, get: row => row.ma_nvbh || '' },
    { header: 'Trạng thái doanh nghiệp', width: 24, get: row => row.ten_tt_dn || row.status || '' },
    { header: 'Nhóm 1', width: 18, get: row => row.nh_kh1 || '' },
    { header: 'Nhóm 2', width: 18, get: row => row.nh_kh2 || '' },
    { header: 'Nhóm 3', width: 18, get: row => row.nh_kh3 || '' },
    { header: 'Điện thoại', width: 18, get: row => row.dien_thoai || '' },
    { header: 'Thư', width: 28, get: row => row.e_mail || '' }
  ]
};

export const exportNhaCungCapExcel = async (entitySlug: string) => {
  const rows = await exportFromApi<NhaCungCapExportRow>({
    entitySlug,
    endpoint: `${QUERY_KEYS.NHA_CUNG_CAP.split('?')[0]}/filter/?is_vendor=true`,
    method: 'POST',
    pageSize: 500,
    file: NHA_CUNG_CAP_EXPORT_FILE,
    skipEmpty: true
  });

  return rows.length;
};
